import { BaseApiClient } from '../BaseApiClient';
import { urls } from '../constants';
export class UsernamesApi extends BaseApiClient {
  constructor(appName) {
    super(appName);
    this.getUserOwnUsername = async () => {
      return this.get(`${urls.identity.usernames.v1}/me`);
    };
    this.createUsername = async body => {
      return this.post(`${urls.identity.usernames.v1}`, body);
    };
    this.deleteUsername = async username => {
      return this.delete(`${urls.identity.usernames.v1}/${username}`);
    };
  }

  /**
   * Get own username of user
   */
}

export default new UsernamesApi('default');